import pagesApi from '@/services/PagesApi'

export default {
  async fetchPages({ commit }) {
    const response = await pagesApi.fetchPages()
    commit('setPages', response.data.data.pages)
  },
  fetchThemes({ commit }, owner = false) {
    return pagesApi.fetchThemes(owner).then(response => {
      commit(
        'setThemes',
        // public is a reserved word in javascript
        response.data.data.themes.map(theme => ({ ...theme, isPublic: theme.public }))
      )
    })
  },
  updateContext({ commit }, context) {
    commit('setContext', context)
  },
  createPage(state, themeId) {
    return pagesApi.savePage({ theme: themeId })
  },
  removeTheme({ commit }, id) {
    return new Promise((resolve, reject) => {
      pagesApi.removeTheme(id).then(({ data }) => {
        if (data.errors) {
          reject()
        } else {
          commit('removeTheme', id)
          resolve()
        }
      })
    })
  },
  saveTheme({ commit }, theme) {
    return new Promise((resolve, reject) => {
      pagesApi.saveTheme(theme).then(({ data }) => {
        if (data.errors) {
          reject()
        } else {
          commit('setTheme', theme)
          resolve()
        }
      })
    })
  },
  copyThemeToProduction(state, themeId) {
    return new Promise((resolve, reject) => {
      pagesApi.copyThemeToProduction(themeId).then(({ data }) => {
        if (data.errors) {
          reject()
        } else {
          resolve()
        }
      })
    })
  },
}
